import React from 'react'
import TreatmentList from './treatment/treatment_components/treatmentList'

export default function Main() {
  return <TreatmentList />
}